// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-link.router-link-active[data-v-74a7656d]{color:#FFCCC}.nav-link.router-link-active[data-v-74a7656d]:before{opacity:1;transform:scaleX(1)}.nav-link.router-link-active[data-v-74a7656d]:after{opacity:1;transform:scale(1)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
